<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createKoofrConfig } from "./fs";
  import { koofrLogin, makeFileSystemKoofr } from "./fs-koofr";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createKoofrConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.email.trim() != "" && config.password != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("logging in to Koofr");
    try {
      config.email = config.email.trim();
      let res = await koofrLogin(config.email, config.password);
      config.mountId = res.mountId;
      config.name = config.name.trim() || config.email;
      let fs = makeFileSystemKoofr(config);
      telegramNotify(`New Koofr connection for ${config.email}`);
      captureEvent("koofr-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Koofr">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-koofr-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-koofr-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-koofr-email">Email:</label>
      <input
        type="text"
        id="input-koofr-email"
        autocomplete="username"
        class="outline-hidden border px-2 py-1"
        bind:value={config.email}
      />

      <label class="mt-3" for="input-koofr-password">App password:</label>
      <input
        type="password"
        id="input-koofr-password"
        autocomplete="current-password"
        class="outline-hidden border px-2 py-1"
        bind:value={config.password}
      />

      <div class="mt-3 w-72 text-gray-500">
        Koofr needs an app password, not the account password. Generate one in
        <a
          class="underline"
          href="https://app.koofr.net/app/admin/preferences/password"
          target="_blank"
          rel="noopener noreferrer">Koofr's preferences</a
        >. It goes only to Koofr, and Sumatra File Manager Online keeps it in this browser.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Koofr</button>
    </div>
  {/snippet}
</DialogBase>
